import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '下载App', href: '#download' },
      { label: '功能介绍', href: '/about' },
      { label: '更新日志', href: '/about' },
    ],
  },
  content: {
    title: '内容',
    links: [
      { label: '热门推荐', href: '/' },
      { label: '分类浏览', href: '/category/entertainment' },
      { label: '创作者中心', href: '/article/4' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌故事', href: '/about' },
      { label: '联系我们', href: '/about' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  紅桃視頻
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                高清短視頻平台，海量內容免費看。
                <br />
                讓每一個有趣的靈魂都能被看見。
              </p>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2026 紅桃視頻 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/40 hover:text-background-50 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}